import 'boot/webpackPublicPath';
import SearchApp from 'search/components/SearchApp';
import { exposeComponents } from 'boot/common/reactMount';

exposeComponents({ SearchApp });
